import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButton } from '@angular/material/button';
import {
  MatCard,
  MatCardActions,
  MatCardContent,
  MatCardHeader,
  MatCardTitle,
} from '@angular/material/card';

@Component({
  selector: 'app-backend-unavailable',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatButton,
    MatCard,
    MatCardActions,
    MatCardContent,
    MatCardHeader,
    MatCardTitle,
  ],
  template: `
    <main class="status-page">
      <mat-card class="status-card" aria-live="polite">
        <mat-card-header>
          <mat-card-title>Backend unavailable</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <p>
            The admin dashboard cannot reach the backend API right now. Check
            the backend service and try again.
          </p>
        </mat-card-content>
        <mat-card-actions align="end">
          <button
            mat-flat-button
            color="primary"
            type="button"
            (click)="reloadPage()"
          >
            Refresh
          </button>
        </mat-card-actions>
      </mat-card>
    </main>
  `,
  styles: [
    `
      .status-page {
        min-height: 100vh;
        display: grid;
        place-items: center;
        padding: 24px;
      }

      .status-card {
        width: min(100%, 480px);
        text-align: left;
      }

      .status-card p {
        margin: 0;
        line-height: 1.5;
      }
    `,
  ],
})
export class BackendUnavailableComponent {
  protected reloadPage(): void {
    window.location.reload();
  }
}
